export const defaultSlickConfig = {
	dots: true,
	infinite: true,
	speed: 300,
	slidesToShow: 1,
	centerMode: true,
	variableWidth: true,
	autoplay: true,
	autoplaySpeed: 2000,
}

export default defaultSlickConfig
